import React from 'react'
import pro1 from '../assets/pro1.jpg'
import pro2 from '../assets/pro2.jpg'
import pro3 from '../assets/pro3.jpg'
import pro4 from '../assets/pro4.jpg'
import pro5 from '../assets/pro5.jpg'
import pro6 from '../assets/pro6.jpg'
import "./projectComp.css"

const ProjectComp = () => {
  return (
    <>
        <div className="projects">
            <h1>My Projects</h1>
            <div className="projects-cards">
                <div className="project">
                    <img src={pro1} alt="pro 1" />
                </div>
                <div className="project">
                    <img src={pro2} alt="pro 1" />
                </div>
                <div className="project">
                    <img src={pro3} alt="pro 1" />
                </div>
                <div className="project">
                    <img src={pro4} alt="pro 1" />
                </div>
                <div className="project">
                    <img src={pro5} alt="pro 1" />
                </div>
                <div className="project">
                    <img src={pro6} alt="pro 1" />
                </div>
            </div>
        </div>
    </>
  )
}

export default ProjectComp